import { X, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePWAInstall } from '@/hooks/usePWAInstall';
import { useTranslation } from 'react-i18next';

export const InstallBanner = () => {
  const { t } = useTranslation();
  const { showBanner, promptInstall, dismissBanner } = usePWAInstall();

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-primary text-primary-foreground p-4 shadow-lg animate-in slide-in-from-bottom duration-300">
      <div className="container mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary-foreground/10 rounded-full">
            <Download className="w-5 h-5" />
          </div>
          <div>
            <p className="font-medium">{t('pwa.installTitle')}</p>
            <p className="text-sm opacity-80">{t('pwa.installDesc')}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="secondary"
            size="sm"
            onClick={promptInstall}
          >
            {t('pwa.install')}
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={dismissBanner}
            className="hover:bg-primary-foreground/10"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};
